"use client";

import { useEffect, useRef, useState } from "react";
import CtaButton from "../ui/buttons/CtaButton";

const GoogleReviews = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const [mounted, setMounted] = useState(false);

  // Ensure this component only renders after hydration
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted || !sectionRef.current) return;

    const script = document.createElement("script");
    script.src =
      "https://cdn.trustindex.io/loader.js?9a994f75558e59392906b5b2849";
    script.async = true;
    script.defer = true;

    sectionRef.current.appendChild(script);

    return () => {
      script.remove();
    };
  }, [mounted]);

  if (!mounted) return null;

  return (
    <section
      id='reviews-section'
      ref={sectionRef}
      className='relative px-2 max-w-325 w-full text-left py-5'
    >
      <div className='mb-6 text-center'>
        <CtaButton
          text='Napísať recenziu'
          href='https://g.page/r/CQrnE9dA6fyPEBM/review'
          targetBlank
        />
      </div>

      <div
        className='trustindex-widget'
        data-ti-widget='google'
        data-ti-id='9a994f75558e59392906b5b2849'
      />
    </section>
  );
};

export default GoogleReviews;
